import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
// import Sidebar from './Sidebar';
// import Drawer from '@material-ui/core/Drawer';
import MainHeader from "./MainHeader";
import Footer from "./Footer";
// import classNames from 'classnames';

// const drawerWidth = 240;

const styles = theme => ({
    content: {
        flexGrow: 1,
        padding: theme.spacing.unit * 2,
        minHeight: 550
    },
    // drawer: {
    //     width: drawerWidth,
    //     flexShrink: 0,
    //     whiteSpace: 'nowrap',
    // },
    // drawerOpen: {
    //     width: drawerWidth,
    //     transition: theme.transitions.create('width', {
    //         easing: theme.transitions.easing.sharp,
    //         duration: theme.transitions.duration.enteringScreen,
    //     }),
    //     background: "#FFFFFF"
    // },
    // drawerClose: {
    //     transition: theme.transitions.create('width', {
    //         easing: theme.transitions.easing.sharp,
    //         duration: theme.transitions.duration.leavingScreen,
    //     }),
    //     overflowX: 'hidden',
    //     width: theme.spacing.unit * 7 + 1,
    //     [theme.breakpoints.up('sm')]: {
    //         width: theme.spacing.unit * 8 + 1,
    //     },
    //     background: "#FFFFFF"
    // },
    
});

class MainLayout extends Component {
    static contextTypes = {
        router: PropTypes.object,
    }

    constructor() {
        super();
        this.state = {
           // open: false,
        };
    }

    defaultMenu(){
        let url = window.location.pathname.split ('/')[1];
        let menu = url === "libraries" ? 1 : url === "teams" ? 2 : 0
        return menu;
    }

    render() {
        const {  classes, children } = this.props;

        return (
            <div>
                <MainHeader/>
                    <section className={`${classes.content}`}>
                    {children}           
                    </section>  
                <Footer/>
            </div>
        )
    }
}

MainLayout.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainLayout);